import { FREIGHT_MODE } from '@types';

export const getFreightModeLabel = (mode: FREIGHT_MODE | 'OTHER') => {
	switch (mode) {
	case 'OTHER':
		return 'Other';
	case FREIGHT_MODE.RAIL:
		return 'Rail';
	case FREIGHT_MODE.COASTAL:
		return 'Coastal';
	case FREIGHT_MODE.ROAD:
	default:
		return 'Road';
	}
};
